export const chatChannel = [{
  uniqueName: 'test_name',
  authorAttributes: {
    avatar: 'images.png',
    name: 'user test',
    user_id: '1'
  },
  attributes: {
    anonymity: false,
    member: [{
      user_id: 2,
      name: 'Test Client',
      avatar: null
    }],
    project_name: 'Projeto teste'
  },
  createdBy: 'system',
  lastMessage: {
    body: 'test',
    author: 'test',
    dateCreated: '06/10/1988',
    sid: '00001',
    dateUpdated: 'Wed May 18 2022 10:16:33 GMT-0300 (Horário Padrão de Brasília)'
  },
  friendlyName: 'GTA',
  sid: 'CHf658d378472f406c9e7054acd5a10e01',
  participants: ''
}];